import React from 'react';
import { FormattedMessage } from 'react-intl-next';

import { cssMap } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';
import { Pressable } from '@atlaskit/primitives/compiled';

import { fg } from '@confluence/feature-gating';

const pressableStyles = cssMap({
	root: {
		backgroundColor: token('color.background.neutral.subtle'),
	},
});

type FeedbackItemProps = {
	showGlobalFeedbackCollector: () => void;
};

export const FeedbackItem = ({ showGlobalFeedbackCollector }: FeedbackItemProps) => {
	const onFeedbackButtonClick = () => showGlobalFeedbackCollector();

	/*
	  Bug 1: the onClick should belong to the AkDropdownItem parent of this
	  component, not the div that it renders. The div doesn't span the whole
	  area of the dropdown item, hence clicking on parts of the 'Feedback'
	  option won't open the dialog, even though the hover-darkening suggested
	  it would.

	  Bug 2: ...and while it's 20% inaccessible to clicking, it's 100%
	  inaccessible to keyboard users
	*/
	return fg('custom-interactive-elements-not-keyboard-focusable') ? (
		<Pressable onClick={onFeedbackButtonClick} testId="feedback-button" xcss={pressableStyles.root}>
			<FormattedMessage
				id="editor-help.fabric.help.center.feedback.item"
				defaultMessage="Feedback"
			/>
		</Pressable>
	) : (
		// eslint-disable-next-line
		<div onClick={onFeedbackButtonClick} data-testid="feedback-button">
			<FormattedMessage
				id="editor-help.fabric.help.center.feedback.item"
				defaultMessage="Feedback"
			/>
		</div>
	);
};
